import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import SetupTab from './setup/SetupTab';
import SettingsTab from './settings/SettingsTab';
import AuditInfoTab from './auditInfo/AuditInfoTab'
import * as Help from 'modules/app/Help'

class AppConfig extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {			
			activeTab: "setupTab"			
		};
	}

	handleTabSelect = (key) => {
		this.setState({
			activeTab: key
		})

	}

	render() {
		const tabs = [
			{ key: "setupTab", title: "Setup", comp: SetupTab, helpKey: Help.appConfigSetupHelpKey },
			{ key: "settingsTab", title: "Settings", comp: SettingsTab, helpKey: Help.appConfigSettingsHelpKey },
			{ key: "auditinfoTab", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.appConfigAuditHelpKey }
		];

		let appConfigTabs = tabs.map(tab => {
			const Comp = tab.comp;
			const active = (this.state.activeTab === tab.key);

			return (
				<Tab key={tab.key} eventKey={tab.key} title={tab.title}>
					<div className='tab-pane'>
						<div className='panel-body'>
							{this.state.activeTab === tab.key &&
								<Comp tabKey={tab.key}
									active={active}
									helpKey={tab.helpKey}
									selectedId={this.props.selectedId}
									title={tab.title} />}
						</div>
					</div>
				</Tab>
			);
		});

		return (
			<div>
				<ContentHeader title="App Config" description="Create and modify project and company info" />
				<ContentBody>
					<Tabs id="dashboardTabs" className="tabs-container" onSelect={this.handleTabSelect} defaultActiveKey={"setupTab"}>
						{appConfigTabs}
					</Tabs>
				</ContentBody>
			</div>
		);
	}
}

AppConfig.defaultProps = {
	selectedId: 1
}

export default AppConfig;



// WEBPACK FOOTER //
// ./src/areas/admin/appConfig/AppConfig.js